// import * as React,{useState} from 'react';
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useHistory } from "react-router-dom";
import Modal from '@mui/material/Modal';
import GreenCheckIcon from "web/assets/svg/GreenCheckMark"
import styled from "styled-components";
import CloseIcon from 'web/assets/images/CloseIcon.png';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: "8px",
};

export default ({ isOpen, toggle, memeberType, callBackAlert, ...props }) => {
    let history = useHistory();

    const [activeState, setActive] = useState('Member')
    return (
        <>
            <Modal
                open={isOpen}
                toggle={toggle}
                onClose={toggle}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Membership >
                    <MainWrapper>
                        <Header>
                            <Button onClick={() => {
                                setActive('Member')
                                toggle()
                            }}>
                                <img src={CloseIcon} className="closeIcon" alt="close-icon" />
                            </Button>
                            {memeberType !== "upgradeGuest" && <p className='title'>Choose a membership plan that is right for you!</p>}
                            {memeberType === "upgradeGuest" && <p className='title'>To access this feature, you must become a Member.</p>}

                        </Header>

                        <div className='mobile-menu'>
                            <BodyWrapper>
                                <Card className={activeState === "Member" ? 'active' : ''} onMouseOver={() => {
                                    setActive('Member')
                                }} onMouseLeave={() => {
                                    setActive('')
                                }}>
                                    <div className='top-section top-section-member'>
                                        <div class="text">
                                            <h3>Member</h3>
                                            <p>Buyer or Seller</p> 
                                        </div>
                                        <div class="triangle"></div>
                                    </div>
                                    <div className="bottom-section">
                                        <ul>
                                            <li><GreenCheckIcon />0.0% Seller transaction fee</li>
                                            <li><GreenCheckIcon />3.0% Buyer transaction fee</li>
                                            <li><GreenCheckIcon />Free subscription for one year</li>
                                            <li><GreenCheckIcon />Credit card or ACH payments</li>
                                            <li><GreenCheckIcon />Buy or sell pallets on the marketplace</li>
                                            <li><GreenCheckIcon />Single location to multi-location setup</li>
                                            <li><GreenCheckIcon />Centralized reporting & POD access</li>
                                            <li><GreenCheckIcon />Post your needs to the open market</li>
                                            <li><GreenCheckIcon />Price needs often, or lock in capacity</li>
                                            <li><GreenCheckIcon />Post your inventory to sell</li>
                                            <li><GreenCheckIcon />Access to bid on new opportunities</li>
                                            <li><GreenCheckIcon />Transact on the marketplace, or privately</li>
                                            <li><GreenCheckIcon />Connect with the PT community</li>
                                            <li><GreenCheckIcon />Access to real-time market data</li>
                                        </ul>
                                    </div>
                                    <div style={{ textAlign: 'center' }}><span className='strikethrough-member-style' style={{ fontSize: '18px' }}>$79.00/month </span><span style={{ fontSize: '22px', 'font-weight': 'bold' }}>/ $0.00</span></div>
                                    <h5 style={{ textAlign: 'center', marginTop: '10px', fontSize: '14px' }}>With promo listed when you register</h5>
                                    <div className='member-button'>
                                        <button onClick={() => {
                                            setActive('Member')
                                            if (props.pageType === 'fromRegistration') props.callBackToRegistration('buyerSeller')
                                            else if (props.pageType === 'upgradeGuest') {
                                                localStorage.setItem('guestUser', false);
                                                localStorage.setItem('postInventory', true);
                                                localStorage.setItem('memberShipType', 'buyerSeller');
                                                localStorage.setItem('guestUserUpgrade', true);
                                                props.callBackToRegistration('buyerSeller')
                                                history.push("/registration");
                                            } else {
                                                localStorage.setItem('guestUser', false);
                                                localStorage.setItem('postInventory', true);
                                                localStorage.setItem('memberShipType', 'buyerSeller');
                                                history.push("/registration");
                                            }
                                        }}>Continue as Member</button>
                                    </div>
                                </Card>
                                {(memeberType !== "upgradeGuest") &&
                                    <Card className={activeState === "Guest" ? 'active' : ''} onMouseOver={() => {
                                        setActive('Guest')
                                    }} onMouseLeave={() => {
                                        setActive('')
                                    }}>
                                        <div className='top-section top-section-guest'>
                                            <div class="text">
                                                <h3>Guest</h3>
                                                <p>Buyer</p>
                                            </div>
                                            <div class="triangle"></div>
                                        </div>
                                        <div className="bottom-section">
                                            <ul>
                                                <li><GreenCheckIcon />3.0% transaction fee</li>
                                                <li><GreenCheckIcon />No monthly subscription</li>
                                                <li><GreenCheckIcon />Credit card payments</li>
                                                <li><GreenCheckIcon />Buy pallets on the marketplace</li>
                                                <li><GreenCheckIcon />Single location setup</li>
                                                <li><GreenCheckIcon />Centralized reporting & POD access</li>
                                            </ul>

                                        </div>
                                        <div style={{ paddingBottom: 20 }}>
                                            <h5 style={{ textAlign: 'center', fontSize: '22px', fontFamily: 'latosemibold' }}>Free</h5>
                                            <div className='guest-button'>
                                                <button onClick={() => {
                                                    setActive('Member')
                                                    if (props.pageType === 'fromRegistration') props.callBackToRegistration('guest')
                                                    else {
                                                        localStorage.setItem('guestUser', true);
                                                        localStorage.setItem('postInventory', true);
                                                        localStorage.setItem('memberShipType', 'guest');
                                                        history.push("/registration");
                                                    }
                                                }}>Continue as Guest</button>
                                            </div>
                                        </div>
                                    </Card>}
                                <Card className={activeState === "PalletTrader" ? 'active' : ''} onMouseOver={() => {
                                    setActive('PalletTrader')
                                }} onMouseLeave={() => {
                                    setActive('')
                                }}>
                                    <div className='top-section top-section-fullManaged'>
                                        <div class="text green-text">
                                            <h3>PalletTrader+</h3>
                                            <p>Managed Solutions</p>
                                        </div>
                                        <div class="triangle"></div>
                                    </div>
                                    <div className="bottom-section">
                                        <ul>
                                            <li><GreenCheckIcon />Pallet solutions for every pallet need</li>
                                            <li><GreenCheckIcon />Single location, to national management</li>
                                            <li><GreenCheckIcon />Supply & redemption programs</li>
                                            <li><GreenCheckIcon />Flexible terms & pricing, fixed or cost plus</li>
                                            <li><GreenCheckIcon />RFP preparation and execution</li>
                                            <li><GreenCheckIcon />Value engineering & TCO optimization</li>
                                            <li><GreenCheckIcon />Dedicated account reps</li>
                                            <li><GreenCheckIcon />Interactive portal to request, track & modify orders</li>
                                            <li><GreenCheckIcon />Claims portal and on-demand QC team</li>
                                            <li><GreenCheckIcon />Real-time KPI dashboard & reporting</li>
                                            <li><GreenCheckIcon />Access to real-time market data</li>
                                            <li><GreenCheckIcon />Centralized invoice & POD repository</li>
                                        </ul>
                                    </div>
                                    <div className='fullManage-button'>
                                        <button onClick={() => {
                                            setActive('Member')
                                            toggle()
                                            history.push('/contact-us')
                                        }}>Learn More</button>
                                    </div>
                                </Card>
                            </BodyWrapper>
                        </div>
                        <div className='web-view-menu'>
                            <BodyWrapper>
                                {(memeberType !== "upgradeGuest") &&
                                    <Card className={activeState === "Guest" ? 'active' : ''} onMouseOver={() => {
                                        setActive('Guest')
                                    }} onMouseLeave={() => {
                                        setActive('')
                                    }}>
                                        <div className='top-section top-section-guest'>
                                            <div class="text">
                                                <h3>Guest</h3>
                                                <p>Self Service Buyer</p>
                                            </div>
                                            <div class="triangle"></div>
                                        </div>
                                        <div className="bottom-section">
                                            <ul>
                                                <li><GreenCheckIcon />3.0% transaction fee</li>
                                                <li><GreenCheckIcon />No monthly subscription</li>
                                                <li><GreenCheckIcon />Credit card payments</li>
                                                <li><GreenCheckIcon />Buy pallets on the marketplace</li>
                                                <li><GreenCheckIcon />Single location setup</li>
                                                <li><GreenCheckIcon />Centralized reporting & POD access</li>
                                            </ul>

                                        </div>
                                        <div style={{ paddingBottom: 20 }}>
                                            <h5 style={{ textAlign: 'center', fontSize: '22px', fontFamily: 'latosemibold' }}>Free</h5>
                                            <div className='guest-button'>
                                                <button onClick={() => {
                                                    setActive('Member')
                                                    if (props.pageType === 'fromRegistration') props.callBackToRegistration('guest')
                                                    else {
                                                        localStorage.setItem('guestUser', true);
                                                        localStorage.setItem('postInventory', true);
                                                        localStorage.setItem('memberShipType', 'guest');
                                                        history.push("/registration");
                                                    }
                                                }}>Continue as Guest</button>
                                            </div>
                                        </div>
                                    </Card>}
                                <Card className={activeState === "Member" ? 'active' : ''} onMouseOver={() => {
                                    setActive('Member')
                                }} onMouseLeave={() => {
                                    setActive('')
                                }}>
                                    <div className='top-section top-section-member'>
                                        <div class="text">
                                            <h3>Member</h3>
                                            <p>Self Service Buyer or Seller</p>
                                        </div>
                                        <div class="triangle"></div>
                                    </div>
                                    <div className="bottom-section">
                                        <ul>
                                            <li><GreenCheckIcon />0.0% Seller transaction fee</li>
                                            <li><GreenCheckIcon />3.0% Buyer transaction fee</li>
                                            <li><GreenCheckIcon />Free subscription for one year</li>
                                            <li><GreenCheckIcon />Credit card or ACH payments</li>
                                            <li><GreenCheckIcon />Buy or sell pallets on the marketplace</li>
                                            <li><GreenCheckIcon />Single location to multi-location setup</li>
                                            <li><GreenCheckIcon />Centralized reporting & POD access</li>
                                            <li><GreenCheckIcon />Post your needs to the open market</li>
                                            <li><GreenCheckIcon />Price needs often, or lock in capacity</li>
                                            <li><GreenCheckIcon />Post your inventory to sell</li>
                                            <li><GreenCheckIcon />Access to bid on new opportunities</li>
                                            <li><GreenCheckIcon />Transact on the marketplace, or privately</li>
                                            <li><GreenCheckIcon />Connect with the PT community</li>
                                            <li><GreenCheckIcon />Access to real-time market data</li>
                                        </ul>
                                    </div>
                                    <div style={{ textAlign: 'center' }}><span className='strikethrough-member-style' style={{ fontSize: '18px' }}>$79.00/month </span><span style={{ fontSize: '22px', 'font-weight': 'bold' }}>/ $0.00</span></div>
                                    <h5 style={{ textAlign: 'center', marginTop: '10px', fontSize: '14px' }}>With promo listed when you register</h5>
                                    <div className='member-button'>
                                        <button onClick={() => {
                                            setActive('Member')
                                            if (props.pageType === 'fromRegistration') props.callBackToRegistration('buyerSeller')
                                            else if (props.pageType === 'upgradeGuest') {
                                                localStorage.setItem('guestUser', false);
                                                localStorage.setItem('postInventory', true);
                                                localStorage.setItem('memberShipType', 'buyerSeller');
                                                localStorage.setItem('guestUserUpgrade', true);
                                                props.callBackToRegistration('buyerSeller')
                                                history.push("/registration");
                                            } else {
                                                localStorage.setItem('guestUser', false);
                                                localStorage.setItem('postInventory', true);
                                                localStorage.setItem('memberShipType', 'buyerSeller');
                                                history.push("/registration");
                                            }
                                        }}>Continue as Member</button>
                                    </div>
                                </Card>
                                <Card className={activeState === "PalletTrader" ? 'active' : ''} onMouseOver={() => {
                                    setActive('PalletTrader')
                                }} onMouseLeave={() => {
                                    setActive('')
                                }}>
                                    <div className='top-section top-section-fullManaged'>
                                        <div class="text green-text">
                                            <h3>PalletTrader+</h3>
                                            <p>Managed Solutions</p>
                                        </div>
                                        <div class="triangle"></div>
                                    </div>
                                    <div className="bottom-section">
                                        <ul>
                                            <li><GreenCheckIcon />Pallet solutions for every pallet need</li>
                                            <li><GreenCheckIcon />Single location, to national management</li>
                                            <li><GreenCheckIcon />Supply & redemption programs</li>
                                            <li><GreenCheckIcon />Flexible terms & pricing, fixed or cost plus</li>
                                            <li><GreenCheckIcon />RFP preparation and execution</li>
                                            <li><GreenCheckIcon />Value engineering & TCO optimization</li>
                                            <li><GreenCheckIcon />Dedicated account reps</li>
                                            <li><GreenCheckIcon />Interactive portal to request, track & modify orders</li>
                                            <li><GreenCheckIcon />Claims portal and on-demand QC team</li>
                                            <li><GreenCheckIcon />Real-time KPI dashboard & reporting</li>
                                            <li><GreenCheckIcon />Access to real-time market data</li>
                                            <li><GreenCheckIcon />Centralized invoice & POD repository</li>
                                        </ul>
                                    </div>
                                    <div className='fullManage-button'>
                                        <button onClick={() => {
                                            setActive('Member')
                                            toggle()
                                            history.push('/contact-us')
                                        }}>Learn More</button>
                                    </div>
                                </Card>
                            </BodyWrapper>
                        </div>

                    </MainWrapper>
                </Membership>
            </Modal>
        </>
    );
}
const Membership = styled.div`
 position: absolute;
    top: 50%;
    left:50%;
    transform: translate(-50%, -50%);
    /* bgcolor: background.paper; */
    border-radius: 8px;
    background-color: #fff;
    @media (max-width:500px) {
        width: calc(100% - 40px);
        margin: 0 auto;
    }
`
const MainWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const Header = styled.div`
    font-size: 20px;
    line-height: 40px;
    font-family: "latobold";
    color: #000000;
    padding: 15px 0px 0px 0px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    flex-direction: column;
    gap: 0;
    justify-content: flex-start;
    line-height: initial;
    margin: 0;
    .title {
        font-size: 30px;
    }
    > button {
        position: absolute;
        padding: 0;
        width: auto;
        background-color: transparent !important;
        right: 23px;
        min-width: auto;
    }
    @media (max-width:903px) {
        .title {
        font-size: 19px;
        margin-top: 22px;
        padding: 5px 20px 0;
        text-align: center;
        }
    }
`
const BodyWrapper = styled.div`
    /* padding: 30px 39px 30px;
    align-items: top;
    gap: 35px;
    display: flex;
    max-height: calc(100vh - 85px);
    overflow: auto; */
    padding: 30px 50px;
    gap: 35px;
    display: flex;
    max-height: calc(100vh - 251px);
    overflow: auto;
    /* padding-bottom: 30px; */
    margin-bottom: 5px;
    @media (max-width:1318px) {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    @media (max-width:903px) {
        display: grid;
        grid-template-columns: 1fr;
    }
    @media (max-width:500px) {
        padding: 30px 20px;

    }
`
const Card = styled.div`
    transition: transform 0.3s ease-in-out;
    &.active {
    transform: scale(1.05);
    }
    box-shadow: 0px 0px 20px 0px #0075ff36;
    border-radius: 16px;
    /* padding: 20px; */
    width: min(75.922vw,350px);
    min-height: 635px;
        height: 100%;
    display: grid;
    grid-template-rows: auto 1fr auto;
    .top-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        > div {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            > button {
            background-color: #0075FF !important;
            color: #fff;
            height: 40px;
            font-size: 18px;
            line-height: 40px;
            padding: 0 10px;
            border-radius: 5px;
            text-transform: capitalize;
        }
        }
        > button {
            height: 45px;
            width: 100%;
            max-width: 243px;
            margin: 10px auto 0;
            text-transform: capitalize;
            font-size: 16px;
            font-family: "latomedium";
            border-radius: 4px;
            &.green-btn{
                background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%) !important
            }
            &.blue-btn {
                background-color: #0075FF !important;

            }
            &.yellow-btn {
                background-color: #f7c600 !important;
            }
        }
        .promocode{
            color: #87CDf1;
            font-size: 14px;
            font-family: "latosemibold";
            align-self: flex-start;
        }
        .text {
            color: #0075FF;
            display: inline-flex;
            flex-direction: column;
            /* gap: 15px; */
            &.green-text {
                color: #01B784;
            }
            h3 {
                font-size: 24px;
                /* line-height: 21px; */
                font-family: "latobold";
                margin: 0;
                color: #0E578A;
            }
            p {
                font-size: 17px;
                /* line-height: 38px; */
                margin: 4px 0;
                color: #0E578A;
                font-family: "latosemibold";
                span {
                    font-size: 20px;
                    line-height: 24px;
                }
            }
        }
    }
    .top-section-guest{
        position: relative;
        background: #95CDED;
        border-radius: 16px 16px 0px 0px;
        padding: 15px;
        height: 109px;            
        .triangle{
            position: absolute;
            width: 0;
            height: 0;
            border-left: 14px solid transparent;
            border-right: 14px solid transparent;
            border-bottom: 14px solid #fff;
            bottom: -2px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .guest-button{
        margin-top: 49px;
        text-align: center;
        button{
            height: 45px;
            width: 250px;
            background: #95CDED;
            color: #0E578A;
            border: none;
            border-radius: 4px;
        }
    }
    .member-button{
        margin-top: 18px;
        text-align: center;
        padding-bottom: 20px;
        button{
            height: 45px;
            width: 250px;
            background: #0E578A;
            color: #fff;
            border: none;
            border-radius: 4px;
        }
    }
    .fullManage-button{
        text-align: center;
        padding-bottom: 20px;
        button{
            height: 45px;
            width: 250px;
            background: #F2CE77;
            color: #3C4251;
            border: none;
            border-radius: 4px;
        }
    }
    .strikethrough-member-style{
        font-size: 22px;
        color: #0075FF;
        position:relative;
        font-family: 'latosemibold';
    }
    .strikethrough-member-style::after {
        content: "";
        position: absolute;
        bottom: 40%;
        left: 0;
        right: 0;
        border-bottom: 1px solid #0075FF;
    }
    .top-section-member{
        position: relative;
        background: #0E578A;
        border-radius: 16px 16px 0px 0px;
        padding: 15px;
        height: 109px;
        h3 {
            font-family: 'latobold' !important;
            color: #fff !important;
        }
        p {
            color: #fff !important;
            font-family: "latosemibold" !important;
        }                    
        .triangle{
            position: absolute;
            width: 0;
            height: 0;
            border-left: 14px solid transparent;
            border-right: 14px solid transparent;
            border-bottom: 14px solid #fff;
            bottom: -2px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .top-section-fullManaged{
        position: relative;
        background: #F2CE77;
        border-radius: 16px 16px 0px 0px;
        padding: 15px;
        height: 109px;            
        .triangle{
            position: absolute;
            width: 0;
            height: 0;
            border-left: 14px solid transparent;
            border-right: 14px solid transparent;
            border-bottom: 14px solid #fff;
            bottom: -2px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .bottom-section {
        padding: 20px 7px 5px;
        border-top: 1px solid #0000001a;
       
        li {
            font-size: 13px;
            font-family: 'latoregular';
            padding-left: 30px;
            position: relative;
            margin-bottom: 4px;
            padding-top: 1px;
            :last-child {
                padding-bottom: 0;
            }
            svg {
                position: absolute;
                top: 0;
                left: 0;
            }
            
        } 
    }
`
const UpgradeGuestModalTitle = styled.div`
    align-items: center;
    justify-content: center;
    text-align:center;
    p{
        font-size: 20px;
    }
`